import { render, staticRenderFns } from "./WebmailDetail.vue?vue&type=template&id=3203aeae&scoped=true&"
import script from "./WebmailDetail.vue?vue&type=script&lang=js&"
export * from "./WebmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./WebmailDetail.vue?vue&type=style&index=0&id=3203aeae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3203aeae",
  null
  
)

component.options.__file = "WebmailDetail.vue"
export default component.exports